import { FC, useState } from "react";
import { Typography, TypographyProps, StackProps, Link } from "@mui/material";
import MetadataListItem, { MetadataListItemProps } from "../MetadataListItem";
import { useTranslation } from "react-i18next";

export interface MetadataListTextItemProps extends TypographyProps {
  title: string;
  children: React.ReactNode | string;
  wrapperProps?: StackProps;
  titleProps?: MetadataListItemProps["titleProps"];
  spaced?: boolean;
  noWrapLongText?: boolean;
  textAlign?: "left" | "right";
}

const MetadataListTextItem: FC<MetadataListTextItemProps> = (props) => {
  const { t } = useTranslation();
  const {
    title,
    children,
    wrapperProps,
    titleProps,
    spaced = false,
    noWrapLongText,
    textAlign = "right",
    ...otherProps
  } = props;
  const [showMore, setShowMore] = useState<boolean>(false);

  const handleShowMore = () => {
    setShowMore((prevState) => !prevState);
  };

  const length = String(children).length;
  const isString = typeof children === "string" || children instanceof String;
  const max = 200;

  return (
    <MetadataListItem title={title} titleProps={titleProps} spaced={spaced} {...wrapperProps}>
      <Typography
        {...otherProps}
        component={"span"}
        title={isString ? (children as string) : undefined}
        sx={{ wordBreak: "break-word", wordWrap: "break-word", textAlign: textAlign }}
      >
        {length > max && !showMore && noWrapLongText !== true && (
          <Link sx={{ color: "inherit" }} underline="none" onClick={handleShowMore}>
            {String(children).substring(0, max)}{" "}
            <span style={{ color: "grey", display: "contents" }}>...{t("button:showMore")}</span>
          </Link>
        )}
        {length > max && showMore && noWrapLongText !== true && (
          <Link sx={{ color: "inherit" }} underline="none" onClick={handleShowMore}>
            {String(children)}
            <span style={{ color: "grey", display: "contents" }}>...{t("button:showLess")}</span>
          </Link>
        )}
        {(length < max || noWrapLongText === true) && children}
      </Typography>
    </MetadataListItem>
  );
};

export default MetadataListTextItem;
